import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTypedDispatch } from "store";
import {
  defineAssistantPage,
  setAssistantSuccessOpen,
} from "features/AssistantPages/AssistantPagesActions";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";
import ViewAssistantPageHeader from "./components/ViewAssistantPageHeader/ViewAssistantPageHeader";
import ViewAssistantPageInfo from "./components/ViewAssistantPageInfo/ViewAssistantPageInfo";
import ViewAssistantPageEditModal from "./components/ViewAssistantPageEditModal/ViewAssistantPageEditModal";
import successChecked from "../../assets/images/successChecked.png";
import { SuccessModal } from "components/SuccessModal";
import { useSelector } from "react-redux";
import * as selector from "store/selectors/assistantPages";
import { ErrorModal } from "components/ErrorModal";

const ViewAssistantPage = () => {
  const { pageCode } = useParams<{
    pageCode: assistantPageCodeEnum;
  }>();
  const dispatch = useTypedDispatch();
  const isSuccessOpen = useSelector(selector.isSuccessOpen);
  const [openErrorModal, setOpenErrorModal] = useState(false);

  const [openEditModal, setOpenEditModal] = useState(false);

  const handleOpenEdit = () => {
    setOpenEditModal(true);
  };
  const handleCloseEdit = () => {
    setOpenEditModal(false);
  };

  const handleOpenSuccess = () => {
    dispatch(setAssistantSuccessOpen(true));
  };

  const handleCloseSuccess = () => {
    dispatch(setAssistantSuccessOpen(false));
  };

  const handleOpenError = () => {
    setOpenErrorModal(true);
  };
  const handleCloseError = () => {
    setOpenErrorModal(false);
  };

  useEffect(() => {
    if (pageCode) {
      dispatch(defineAssistantPage(pageCode));
    }
  }, [pageCode]);

  return (
    <Box>
      <ViewAssistantPageHeader
        pageCode={pageCode}
        handleOpenEdit={handleOpenEdit}
      />
      <ViewAssistantPageInfo />
      <ViewAssistantPageEditModal
        open={openEditModal}
        handleClose={handleCloseEdit}
        handleOpenSuccess={handleOpenSuccess}
        handleOpenError={handleOpenError}
      />
      <SuccessModal
        title="Changes have been saved!"
        icon={successChecked}
        open={isSuccessOpen}
        handleClose={handleCloseSuccess}
      />
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseError}
        title="Failed to update assistant page"
        subtitle="Please try again or contact support"
      />
    </Box>
  );
};

export default ViewAssistantPage;
